import { createSlice } from '@reduxjs/toolkit'

import { updateBillingInformation } from 'features/billing/actions/update_billing_information'

const initialState = {
  status: 'initial',
  error: null
}

const updateBillingInformationSlice = createSlice({
  name: 'updateBillingInformation',
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(updateBillingInformation.pending, (state) => {
      state.status = 'pending'
      state.error = null
    })
    builder.addCase(updateBillingInformation.fulfilled, (state) => {
      state.status = 'completed'
    })
    builder.addCase(updateBillingInformation.rejected, (state, action) => {
      state.status = 'completed'
      state.error = action.payload
    })
  }
})

export const {
  reducer,
  actions: {
    reset
  }
} = updateBillingInformationSlice
